import { postData } from "../../../const/apiHelper";

export const createUserApi = async (data) => {
  try {
    await postData("/vendedores", data);
  } catch (error) {
    console.error("Error al registrar el usuario:", error);
  }
};
